import React, { useEffect, useState } from "react";

import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";
/*
 * AdChoicesLink is our own implementation of [evidon-notice-link]
 * since we using 4 types of footer it is easier to have our own link and use window.evidon.notice API to show a popup
 * https://community.crownpeak.com/t5/Headless-Consent-CaaS/The-Consent-Platform-UCP-JavaScript-API-Documentation/ta-p/7647
 */

// Extend the Window interface to include the `OneTrust` property
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    OneTrust?: any;
  }
}

const ERROR: string = `No Active Domain has been loaded for AdChoices. It is ok for local environment.`;

const handleCsp = (e: React.MouseEvent<HTMLButtonElement>): void => {
  e?.preventDefault();
  if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === "function") {
    try {
      GA4.onModalViewed({
        name: "AdChoices Modal",
        text: "AdChoices - Do Not Sell or Share",
        location: "footer",
      });
      window.OneTrust.ToggleInfoDisplay();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("OneTrust error.", error);
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn(ERROR);
  }
};

type Props = {
  isLightTheme: boolean;
};

export const AdChoicesLink: React.FC<Props> = ({ isLightTheme }) => {
  const [apiLoaded, setApiLoaded] = useState<boolean>(true); // leaving as true for now while we debug with OneTrust

  useEffect(() => {
    let cspInterval: NodeJS.Timeout | undefined;
    let cnt: number = 0;

    // Check for the environment variable before starting the interval
    if (process.env.NEXT_PUBLIC_RENDER_CSP === "1") {
      cspInterval = setInterval(() => {
        if (cnt === 20) {
          clearInterval(cspInterval);
          // eslint-disable-next-line no-console
          console.error(ERROR);
        }
        if (window.OneTrust) {
          setApiLoaded(true);
          // eslint-disable-next-line no-console
          console.log("OneTrust loaded.");
          clearInterval(cspInterval);
        } else {
          cnt++;
        }
      }, 500);
    }

    return () => {
      return cspInterval && clearInterval(cspInterval);
    };
  }, []);

  return apiLoaded ? (
    <div className={process.env.NEXT_PUBLIC_RENDER_CSP === "1" ? "block" : "hidden"}>
      <button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleCsp(e)}
        aria-label="AdChoices - Do Not Sell Or Share (Opens in a popup)"
        className="flex items-center gap-1"
      >
        <Picture
          src="https://images.ctfassets.net/0rbfqd9c4jdo/67omLa2eBNjoa4pKRjDlMO/4bc217b04e515416bc81fdee2b62c63c/daa-icon.png"
          alt="AdChoices"
          className="w-3 h-3 -mt-[1px]"
        />

        <TextElementNova
          element="span"
          className={cn("Body-10-Dia-Normal inline-block text-nova-base-white", {
            "text-nova-base-black": isLightTheme,
          })}
          text="AdChoices - Do Not Sell Or Share"
        />
      </button>
    </div>
  ) : null;
};
